import axios from "axios";
import { environment } from "../environment/environment";
import gatewayService from "@/services/gateway-service";

const policyService = {
    async getMetrics(pendingPayments) {
        let result = await axios.get(`${environment.api}policies/metrics?pendingPayments=${pendingPayments}`);
        
        return result;
    },
    async getCollection(year, month) {
        let result = await axios.get(`${environment.api}policies/collection?year=${year}&month=${month}`);
        
        return result;
    },
    async getPersistence() {
        let result = await axios.get(`${environment.api}policies/persistence`);
        
        return result;
    },

    async postEmission(dataEmision){

        try{
            let oldClientData = JSON.parse(window.localStorage.getItem("__maskedClient__") || '{}');
            let currentClientData = JSON.parse(window.localStorage.getItem("__quoteUserEdit__") || '{}');
            const requestBody = {
                api_id: environment.apiGatewayEmission,
                body: dataEmision,
                product: "RUMBO",
                replace: gatewayService.getChangesCustomerData("asegurado.",currentClientData, oldClientData),

            };
            return gatewayService.postApiGateway(requestBody)
        } catch (error) {
            console.error('Error', error);
        }
    },
    async postCulqiToken(objCulqi){

        try{
            let oldClientData = JSON.parse(window.localStorage.getItem("__maskedClient__") || '{}');
            let currentClientData = JSON.parse(window.localStorage.getItem("__quoteUserEdit__") || '{}');
            const requestBody = {
                api_id: environment.apiCulqiToken,
                body: objCulqi,
                product: "RUMBO",
                replace: gatewayService.getChangesCustomerData("",currentClientData, oldClientData),
            };
            return gatewayService.postApiGateway(requestBody)
        } catch (error) {
            console.error('Error', error);
        }
    },
    async postConsentimiento(model){

        try{
            let oldClientData = JSON.parse(window.localStorage.getItem("__maskedClient__") || '{}');
            let currentClientData = JSON.parse(window.localStorage.getItem("__quoteUserEdit__") || '{}');
            const requestBody = {
                api_id: environment.isApiTermConditions,
                body: model,
                product: "RUMBO",
                replace: gatewayService.getChangesCustomerData("",currentClientData, oldClientData),
            };
            return gatewayService.postApiGateway(requestBody)
        } catch (error) {
            console.error('Error', error);
        }
    },
}

export default policyService;